import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/tensormap/tensormap/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/runner/work/tensormap/tensormap/node_modules/.c12/gh_NMGResources_Inc_5FWKXjacha/layouts/empty.vue").then(m => m.default || m)),
  iconnav: defineAsyncComponent(() => import("/home/runner/work/tensormap/tensormap/node_modules/.c12/gh_NMGResources_Inc_ObKXa1Xih/layouts/iconnav.vue").then(m => m.default || m))
}